import { ArDashboard } from "~/features/ar-dashboard/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const DashboardPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxLtlArDashboard");

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? <ArDashboard /> : <Construction />;
};
